import { useApiGroundControlSettingsRetrieve } from 'api';
import { type SyntheticEvent, useState } from 'react';
import { Box, buildTabA11yProps, Tab, TabPanel, Tabs } from 'ui';

import { getTabs } from '../../data';
import { NavGrid } from '../NavGrid/NavGrid';
import { TabNavigationItem } from '../TabNavigationItem/TabNavigationItem';

const INITIAL_TAB = 0;

export const TabNavigation = () => {
  const [currentTab, setCurrentTab] = useState(INITIAL_TAB);
  const { data: groundControlSettings } = useApiGroundControlSettingsRetrieve();

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  const navTabsData = getTabs(groundControlSettings);
  return (
    <Box>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          maxWidth: '84dvw',
        }}
      >
        <Tabs
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          value={currentTab}
          onChange={handleChange}
          aria-label="ground control tabs"
        >
          {navTabsData.map(({ label, icon }, index) => (
            <Tab label={label} icon={icon} key={index} {...buildTabA11yProps(index)} />
          ))}
        </Tabs>
      </Box>

      {navTabsData.map(({ links }, index) => (
        <TabPanel value={currentTab} index={index} key={index}>
          <NavGrid>
            {links?.map(({ label, icon, href, description, isLegacy }, index) =>
              isLegacy === false ? (
                <TabNavigationItem key={index} label={label} icon={icon} to={href} description={description} />
              ) : (
                <TabNavigationItem key={index} label={label} icon={icon} href={href} description={description} />
              )
            )}
          </NavGrid>
        </TabPanel>
      ))}
    </Box>
  );
};
